import React from "react";
import { useAuth0 } from "../../hooks/useAuth0";
import { Box, Paper, Typography, Button } from "@mui/material";

const DebugAuth = () => {
  const { user, getAccessTokenSilently, isAuthenticated } = useAuth0();
  const [tokenInfo, setTokenInfo] = React.useState(null);

  const decodeToken = async () => {
    try {
      const token = await getAccessTokenSilently();

      // Decode JWT (just for viewing - this is safe for debugging)
      const base64Url = token.split(".")[1];
      const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
      const jsonPayload = decodeURIComponent(
        atob(base64)
          .split("")
          .map((c) => "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2))
          .join("")
      );

      setTokenInfo(JSON.parse(jsonPayload));
    } catch (error) {
      console.error("Error getting token:", error);
    }
  };

  if (!isAuthenticated) {
    return <Typography>Not authenticated</Typography>;
  }

  return (
    <Box sx={{ p: 3 }}>
      <Paper sx={{ p: 3, mb: 2 }}>
        <Typography variant="h6" gutterBottom>
          Auth0 User Object
        </Typography>
        <pre
          style={{
            background: "#f5f5f5",
            padding: "16px",
            borderRadius: "4px",
            overflow: "auto",
            fontSize: "12px",
          }}
        >
          {JSON.stringify(user, null, 2)}
        </pre>
      </Paper>

      <Button variant="contained" onClick={decodeToken} sx={{ mb: 2 }}>
        Decode Access Token
      </Button>

      {tokenInfo && (
        <Paper sx={{ p: 3 }}>
          <Typography variant="h6" gutterBottom>
            Access Token Payload
          </Typography>
          <pre
            style={{
              background: "#f5f5f5",
              padding: "16px",
              borderRadius: "4px",
              overflow: "auto",
              fontSize: "12px",
            }}
          >
            {JSON.stringify(tokenInfo, null, 2)}
          </pre>
        </Paper>
      )}
    </Box>
  );
};

export default DebugAuth;
